import { ExecutionResult } from 'react-apollo';
import { DataProxy } from 'apollo-cache';
import produce from 'immer';

import {
  FeedByUser,
  GenericStatus,
  UserProfile,
  GetCurrentUserFeedDocument,
  CreateUpdateLeaderboardConfigMutation,
} from 'api';

type ToggleLeaderboard = [
  DataProxy,
  ExecutionResult<CreateUpdateLeaderboardConfigMutation>,
  UserProfile,
];

export default (...args: ToggleLeaderboard) => {
  const [cache, mutationResult, currentUser] = args;
  const { createUpdateLeaderboardConfig } = mutationResult.data;
  const { all_users, leaderboard_status } = createUpdateLeaderboardConfig;

  if (!all_users) {
    return;
  }

  const userFeedCacheOptions = {
    query: GetCurrentUserFeedDocument,
    variables: { user_id: currentUser.id },
  };

  const { getByUserFeed } = cache.readQuery(userFeedCacheOptions);

  const nextGetByUserFeed = produce(getByUserFeed, (draft: FeedByUser) => {
    draft.user.leaderboard_enabled = leaderboard_status === GenericStatus.Active;
    return draft;
  });

  cache.writeQuery({
    data: { getByUserFeed: nextGetByUserFeed },
    ...userFeedCacheOptions,
  });
};
